var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MonitoringDataTable',{attrs:{"loading":_vm.loading,"mails":_vm.mails,"units":_vm.units,"total":_vm.total,"allow-create-print-package":false,"allow-operations":false},on:{"update":_vm.onUpdate,"excel":_vm.onExcel}})
}
var staticRenderFns = []

export { render, staticRenderFns }